import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
const criteria = [{
  yes: 'Tenés un hijo de 6 a 10 años con dificultades lectoras',
  no: 'Buscás un curso de fonética para adultos'
}, {
  yes: 'Querés ayudarlo pero no sabés por dónde empezar',
  no: 'No te interesa seguir un protocolo paso a paso'
}, {
  yes: 'Las sesiones de lectura terminan en tensión o llanto',
  no: 'Creés que lo tiene que resolver el colegio solo'
}, {
  yes: 'Lee pero no entiende o silabea sin poder fluir',
  no: 'Pensás que las dificultades se van a resolver solas'
}, {
  yes: 'Necesitás un sistema claro de 10 minutos por día',
  no: 'No querés dedicar 10 minutos diarios a acompañarlo'
}, {
  yes: 'No querés volver a perder la paciencia leyendo',
  no: 'Buscás una solución mágica sin involucrarte'
}];
export function IsThisForYou() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-186">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-187">
        <div className="text-center mb-8" data-id="element-188">
          <h2 className="text-3xl md:text-5xl font-bold text-navy" data-id="element-189">
            ¿ESTE SISTEMA ES PARA VOS?
          </h2>
        </div>

        <div className="rounded-3xl border border-slate-100 overflow-hidden shadow-sm" data-id="element-190">
          <table className="w-full table-fixed border-collapse" data-id="element-191">
            <thead data-id="element-192">
              <tr data-id="element-193">
                <th className="w-1/2 bg-emerald-50 border-b border-emerald-100/70 px-3 py-4 sm:px-5" data-id="element-194">
                  <div className="flex items-center justify-center gap-2" data-id="element-195">
                    <CheckCircle2 className="w-5 h-5 text-emerald-600 flex-shrink-0" data-id="element-196" />
                    <span className="text-sm sm:text-lg font-bold text-emerald-900" data-id="element-197">
                      SÍ ES PARA VOS
                    </span>
                  </div>
                </th>
                <th className="w-1/2 bg-rose-50 border-b border-l border-rose-100/70 px-3 py-4 sm:px-5" data-id="element-198">
                  <div className="flex items-center justify-center gap-2" data-id="element-199">
                    <XCircle className="w-5 h-5 text-rose-500 flex-shrink-0" data-id="element-200" />
                    <span className="text-sm sm:text-lg font-bold text-rose-900" data-id="element-201">
                      NO ES PARA VOS
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-202">
              {criteria.map((c, i) => <tr key={i} className="align-top" data-id="element-203">
                  <td className="bg-emerald-50/40 border-b border-emerald-100/50 px-3 py-3 sm:px-5 sm:py-4" data-id="element-204">
                    <div className="flex items-start gap-2" data-id="element-205">
                      <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-206" />
                      <span className="text-xs sm:text-base text-emerald-900 font-medium leading-snug" data-id="element-207">
                        {c.yes}
                      </span>
                    </div>
                  </td>
                  <td className="bg-rose-50/40 border-b border-l border-rose-100/50 px-3 py-3 sm:px-5 sm:py-4" data-id="element-208">
                    <div className="flex items-start gap-2" data-id="element-209">
                      <XCircle className="w-4 h-4 sm:w-5 sm:h-5 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-210" />
                      <span className="text-xs sm:text-base text-rose-900 leading-snug" data-id="element-211">
                        {c.no}
                      </span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}